import { BaseComponentPlus } from "react-vextensions";
import { HSLA } from "vwebapp-framework";
export class UIFocusEngine_OverlayUI extends BaseComponentPlus({}, {}) {
    ComponentDidMount() {
        UIFocusEngine_OverlayUI.main = this;
    }
    ComponentWillUnmount() {
        UIFocusEngine_OverlayUI.main = null;
    }
    RefreshFor(uiFocusEngine) {
        this.uiFocusEngine = uiFocusEngine;
        this.Update();
    }
    render() {
        if (this.uiFocusEngine == null || !this.uiFocusEngine.voiceEngine.enabled)
            return null;
        const textOutline = "rgba(0,0,0,1)";
        const {} = this.props;
        return (React.createElement("div", { className: "clickThroughChain", style: {
                position: "fixed", left: 0, right: 0, top: 0, bottom: 0, zIndex: 13,
                filter: Array(5).fill("drop-shadow(0px 0px 1px rgba(0,0,0,1))").join(" "),
            } }, this.uiFocusEngine.controlInfos.map(info => {
            return (React.createElement("div", { key: info.index, style: {
                    position: "fixed", right: `calc(100% - ${info.labelPos.x}px)`, top: info.labelPos.y, fontSize: 10,
                    color: HSLA(120, 1, .5),
                    textShadow: `-1px 0 ${textOutline}, 0 1px ${textOutline}, 1px 0 ${textOutline}, 0 -1px ${textOutline}`,
                } }, info.labelText));
        })));
    }
}
